// extracted by mini-css-extract-plugin
export default {"anchoredOverlay":"IconAndColorPicker-module__anchoredOverlay--YlETW"};